import {Injectable} from '@angular/core';
import {DeliveryClient, DeliveryClientConfig, TypeResolver} from 'kentico-cloud-delivery-typescript-sdk';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {Project} from '../models/project';
import {StoryBlock} from '../models/story_block';
import {WideImage} from '../models/wide_image';


@Injectable()
export class KenticoService {
  private deliveryClient: DeliveryClient;
  private contentItems;

  constructor() {
    const typeResolvers: TypeResolver[] = [
      new TypeResolver('project', () => new Project()),
      new TypeResolver('story_block', () => new StoryBlock()),
      new TypeResolver('wide_image', () => new WideImage()),
    ];

    let options = {};

    if (!environment.production) {
      options = {
        enablePreviewMode: true,
        previewApiKey: KenticoService.getPreviewApiKey()
      };
    }

    this.deliveryClient = new DeliveryClient(
      new DeliveryClientConfig(
        KenticoService.getProjectId(),
        typeResolvers,
        options
      )
    );
    this.contentItems = this.deliveryClient.items().get().publishReplay(1).refCount();
  }

  static getProjectId() {
    return environment.kenticoConfig.projectId;
  }

  static getPreviewApiKey() {
    return environment.kenticoConfig.previewApiKey;
  }

  getSingleType(type: String): Observable<any> {
    return this.contentItems.map(response => {
      return response.items.filter(item => {
        return item.system.type === type;
      })[0];
    });
  }

  getProjects(): Observable<Project[]> {
    return this.contentItems.map(response => {
      return response.items.filter(item => item.system.type === 'project');
    });
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/services/kentico.service.ts